import { createGlobalStyle } from 'styled-components'
import { theme } from '@aserto/aserto-react-components'

export const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell',
    'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${theme.primaryBlack};
    color: ${theme.grey70};
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: ${theme.grey10};
  }
  &::-webkit-scrollbar-thumb {
    background: ${theme.grey40};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    margin: 4px;
    border-radius: 10px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Open Sans', sans-serif;
    color: ${theme.grey100};
  }

  code {
    font-family: 'Ubuntu Mono', source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  /* link treatment */
  a {
    color: ${theme.lochivarAccent3};
  }
  a:hover {
    color: ${theme.lochivarAccent3};
  }

  @media (max-width: 1200px) {
    .left-item {
      border-top: 1px solid #414141;
      a {
        margin-top: 20px !important;
      }
    }

    .navbar-nav:last-child {
      margin-left: 1.5rem !important;
      margin-right: 1.5rem !important;
    }
  }
  @media (min-width: 1200px) {

    .left-item:after {
      content: "";
      background: #414141;
      position: absolute;
      bottom: 16px;
      height: 50%;
      right: 206px;
      width: 1px;
    }

    .navbar-nav:last-child {
      padding: 0px !important;
      margin: 0px !important;
    }

    .nav-item {
      height: 60px !important;
    }

  }



`
